import { useEffect, useRef, useState } from 'react'
import { Alert, Button, Form, Spinner } from 'react-bootstrap'
import { Link, useSearchParams } from 'react-router-dom'

import PaginaPublica from '../../components/Auth/PaginaPublica'
import api from '../../services/api'
import { mensajeDeError, normalizarCorreo } from '../../utils/registroPublico'

/**
 * La liga del correo: `/registro/verificar?token=…`. Confirma la cuenta al abrirla.
 *
 * La verificación es idempotente en el backend, así que el doble montaje de React en desarrollo
 * no crea nada dos veces; aun así `pedido` evita la segunda llamada.
 */
export default function VerificarCorreo() {
  const [params] = useSearchParams()
  const token = params.get('token') || ''
  const pedido = useRef(false)

  const [estado, setEstado] = useState('cargando')   // cargando | listo | vencida | error
  const [datos, setDatos] = useState(null)
  const [error, setError] = useState('')
  const [email, setEmail] = useState('')
  const [reenviado, setReenviado] = useState('')

  useEffect(() => {
    if (pedido.current) return
    pedido.current = true
    api.post('/auth/registro/verificar/', { token })
      .then((r) => {
        setDatos(r.data)
        setEstado('listo')
      })
      .catch((e) => {
        setError(mensajeDeError(e))
        setEstado(e?.response?.status === 410 ? 'vencida' : 'error')
      })
  }, [token])

  const reenviar = async (e) => {
    e.preventDefault()
    try {
      const r = await api.post('/auth/registro/reenviar/', { email: normalizarCorreo(email) })
      setReenviado(r.data?.detail)
    } catch (err) {
      setReenviado(mensajeDeError(err))
    }
  }

  let cuerpo
  if (estado === 'cargando') {
    cuerpo = <div className="text-center py-4"><Spinner animation="border" /></div>
  } else if (estado === 'listo') {
    const enFila = datos?.estado === 'en_espera'
    cuerpo = (
      <>
        <Alert variant="success" data-testid="verificado">
          <strong>Tu cuenta está activa.</strong>{' '}
          {enFila
            ? <>Tus timbres de cortesía están en camino: estás en el <strong>lugar {datos.lugar_en_fila}</strong> de
                la fila. Mientras tanto ya puedes entrar, dar de alta tu contribuyente y cargar tu
                certificado. Te avisaremos por correo, y tus días de prueba empiezan a contar ese día.</>
            : <>Ya tienes tus timbres de cortesía: te mandamos un correo con los detalles.</>}
        </Alert>
        <p className="small">Tu usuario es <strong>{datos?.usuario}</strong>.</p>
        <Button as={Link} to="/login" className="w-100 login-submit">Entrar</Button>
      </>
    )
  } else if (estado === 'vencida') {
    cuerpo = (
      <>
        <Alert variant="warning">{error}</Alert>
        {reenviado ? (
          <Alert variant="info" className="mb-0">{reenviado}</Alert>
        ) : (
          <Form onSubmit={reenviar}>
            <Form.Group className="mb-3" controlId="verificarEmail">
              <Form.Label>Tu correo</Form.Label>
              <Form.Control type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                            autoComplete="email" required />
            </Form.Group>
            <Button type="submit" className="w-100 login-submit">Mandarme una liga nueva</Button>
          </Form>
        )}
      </>
    )
  } else {
    cuerpo = (
      <>
        <Alert variant="danger">{error}</Alert>
        <p className="small mb-0">
          ¿Ya confirmaste antes? <Link to="/login">Inicia sesión</Link>.
        </p>
      </>
    )
  }

  return (
    <PaginaPublica titulo="Confirma tu correo" encabezado="Confirmación de cuenta">
      {cuerpo}
    </PaginaPublica>
  )
}
